// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"90882f9f","466":"782dc46e","738":"c957970a","856":"01bfcdb4"}[chunkId] + ".chunk.js";
};